<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import PrimaryNavigation from "@/components/layout/PrimaryNavigation.vue";
import MobileNavigation from "@/components/layout/MobileNavigation.vue";
import BillyBotDrawer from "@/components/billybot/BillyBotDrawer.vue";
import CategoriesDrawer from "@/components/CategoriesDrawer.vue";
import { useRequestSurveyStore } from "@/stores/requestSurvey";
import MobileAppHeader from "@/components/layout/MobileAppHeader.vue";

defineProps({
  noPadding: {
    type: Boolean,
    default: false,
  },
});

const requestSurveyStore = useRequestSurveyStore();
const route = useRoute();
const hasMobileNavigation = computed(() => {
  return route.name !== "Request";
});
</script>

<template>
  <div
    :class="[
      'grid min-h-screen grid-cols-1 lg:grid-cols-[275px_1fr] lg:grid-rows-1',
      { 'grid-rows-[1fr_88px]': hasMobileNavigation },
    ]"
  >
    <PrimaryNavigation />
    <div class="flex flex-col">
      <MobileAppHeader><slot name="mobile-header" /></MobileAppHeader>
      <main :class="['flex flex-1 flex-col', { 'p-2 sm:p-8': !noPadding }]">
        <Suspense>
          <slot />
        </Suspense>
      </main>
    </div>
    <MobileNavigation v-if="hasMobileNavigation" />
    <CategoriesDrawer
      v-model:open="requestSurveyStore.categoryDrawerOpen"
      :mode="requestSurveyStore.categoryDrawerMode"
    />
    <BillyBotDrawer v-model:open="requestSurveyStore.requestDrawerOpen" />
  </div>
</template>
